import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var UserPermissionError = /*#__PURE__*/function (_Error) {
  _inherits(UserPermissionError, _Error);
  var _super = _createSuper(UserPermissionError);
  function UserPermissionError(description) {
    var _this;
    _classCallCheck(this, UserPermissionError);
    _this = _super.call(this, description);
    _this.description = description;
    _this.name = 'UserPermissionError';
    return _this;
  }
  return _createClass(UserPermissionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var InvalidGoalError = /*#__PURE__*/function (_Error2) {
  _inherits(InvalidGoalError, _Error2);
  var _super2 = _createSuper(InvalidGoalError);
  function InvalidGoalError(description) {
    var _this2;
    _classCallCheck(this, InvalidGoalError);
    _this2 = _super2.call(this, description);
    _this2.description = description;
    _this2.name = 'InvalidGoalError';
    return _this2;
  }
  return _createClass(InvalidGoalError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var InvalidRelationshipError = /*#__PURE__*/function (_Error3) {
  _inherits(InvalidRelationshipError, _Error3);
  var _super3 = _createSuper(InvalidRelationshipError);
  function InvalidRelationshipError(description) {
    var _this3;
    _classCallCheck(this, InvalidRelationshipError);
    _this3 = _super3.call(this, description);
    _this3.description = description;
    _this3.name = 'InvalidRelationshipError';
    return _this3;
  }
  return _createClass(InvalidRelationshipError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var getDefaultAtlasBaseURL = function getDefaultAtlasBaseURL(subdomainName) {
  var hostname = window.location.hostname;
  var subdomain = subdomainName ? subdomainName : 'team';
  if (hostname.includes('jira-dev.com') || hostname.includes('.stg.atlassian.') || hostname.startsWith('localhost')) {
    return "https://".concat(subdomain, ".stg.atlassian.com");
  }
  return "https://".concat(subdomain, ".atlassian.com");
};